import type { PurchasePaymentBreakdown } from '../../../services/purchase-payments-api.types';

export const getCashDownLabel = (paymentType: string, shippingFee: number) => {
  if (paymentType === 'Cash') {
    return shippingFee > 0 ? 'Subtotal' : 'Total vehicle price';
  }

  return 'Cash down payment';
};

export const shippingFeeLabel = 'Nonrefundable shipping';

export const creditLabel = 'Payments applied';

export const getPurchasePaymentBreakdownLineItems = (
  paymentType: string,
  purchasePaymentBreakdown: PurchasePaymentBreakdown
) => {
  const { cashDown, shippingFee, credit } = purchasePaymentBreakdown;

  const lineItems: { label: string; amount: number }[] = [];

  if (cashDown > 0) {
    lineItems.push({ label: getCashDownLabel(paymentType, shippingFee), amount: cashDown });
  }

  if (shippingFee > 0) {
    lineItems.push({ label: shippingFeeLabel, amount: shippingFee });
  }

  if (credit > 0) {
    lineItems.push({ label: creditLabel, amount: -credit });
  }

  return lineItems;
};
